import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {Image} from '@app/components/Image';
import {useLocation} from '@app/hooks/use-location';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const LyricsAcross: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'lyricslandingpage_title_lyricsacrossallyourdevices_standalone-web',
							{ns: 'lyrics'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'lyricslandingpage_text_lyricsacrossallyourdevices_standalone-web',
							{ns: 'lyrics'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					quality={85}
					src="9c790532b978e7eb3b6d58848f4ca2c5.png"
					aspectRatio="2048/757"
					alt={t('metatag_text_lyricsonseveraldevices_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'devices'}}
					href={getDeezerUrl('/devices')}
					target="_blank"
				>
					{t('generic_action_seeallourdevices_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
